import type {OrderFormState} from '../../../types'

export function toRoute(formState: OrderFormState) {
  const route = formState.route

  return route
    ? Object.keys(route).flatMap(key => {
        // если адрес не установлен, не передаем точку
        return route[key]?.address?.coordinates
          ? {
              type: key === 'source' || key === 'return' ? key : 'destination',
              coordinates: route[key].address.coordinates,
              uri: route[key].address.uri,
            }
          : []
      })
    : []
}
